import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/AppHome.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/dashboard/:platform/:id/:token',
      name: 'dashboard',
      component: () => import(/* webpackChunkName: "inside" */ './views/AppDashboard.vue')
    },
    {
      path: '/multi-dashboard/:platform/:dashboard/:token',
      name: 'multi-dashboard',
      component: () => import(/* webpackChunkName: "inside" */ './views/AppMultiDashboard.vue')
    },
    {
      path: '/mod-dashboard/:platform/:dashboard/:token',
      name: 'mod-dashboard',
      component: () => import(/* webpackChunkName: "inside" */ './views/AppModDashboard.vue')
    },
    {
      path: '/test/:token',
      name: 'test',
      component: () => import(/* webpackChunkName: "inside" */ '@/components/dashboards/rm/DashboardRmAppointments')
    },
    {
      path: '/widget/:id/:key/:token',
      name: 'widget',
      component: () => import(/* webpackChunkName: "inside" */ './views/AppWidget.vue')
    },
    {
      path: '*',
      name: 'page-not-found',
      component: () => import(/* webpackChunkName: "404" */ './pages/Page404.vue')
    }
  ]
})
